<nz-row [nzGutter]="[16, 16]">
  <ng-container *ngFor="let iframe of iframes; let i = index">
    <nz-col [nzXs]="24" [nzSm]="iframes.length > 1 ? 12 : 24" [nzMd]="iframes.length > 1 ? 12 : 24">
      <iframe [src]="iframe" style="width: 100%; height: calc(100vh - 250px); border: none"></iframe>
    </nz-col>
  </ng-container>
</nz-row>
